import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import Input from "../../form/input";
import Select from "../../form/select";
import Textarea from "../../form/textarea";
import LoadingButton from "../../common/loadingButton";
import { submitFactor } from "../../../services/dashboard";

const usageOptions = [
  { label: "آزمایش خون", value: "BLOOD_TEST", id: 1 },
  { label: "آزمایش ادرار", value: "URINE_TEST", id: 2 },
  { label: "آزمایش مدفوع", value: "STOOL_TEST", id: 3 },
];

const resultTypeOptions = [
  { label: "TEXT", value: "TEXT", id: 1 },
  { label: "BOOL", value: "BOOL", id: 2 },
  { label: "FLOAT", value: "FLOAT", id: 3 },
  { label: "INT", value: "INT", id: 4 },
];

const sexOptions = [
  { label: "هر دو", value: "both", id: 1 },
  { label: "مرد", value: "male", id: 2 },
  { label: "زن", value: "female", id: 3 },
];

const componentStateOptions = [
  { label: "بالا", value: "H", id: 1 },
  { label: "پایین", value: "L", id: 2 },
];

const typeOptions = [
  { label: "دلیل", value: "R", id: 1 },
  { label: "مشکل", value: "P", id: 2 },
];

// Yup validation schema
const schema = yup.object().shape({
  // subject: yup.string().required(" موضوع پیام الزامی است"),
  // email: yup
  //   .string()
  //   .email("فرمت ایمیل اشتباه است")
  //   .required("ایمیل الزامی است"),
  // message: yup.string().required(" متن پیام الزامی است"),
});

const InvalidComponentsForm = () => {
  const {
    handleSubmit,
    formState: { errors, isValid, isDirty },
    control,
    reset,
    ...form
  } = useForm({
    resolver: yupResolver(schema),
    mode: "onTouched",
  });

  const onSubmit = (data: any) => {
    const submitData = {
      ...data,
      normal_situation: [`${data.normal_situation}`],
      similar_names: [...data.similar_names.split(" ")],

      reasons_and_problems: [
        {
          sex: data.rp_sex,
          component_state: data.rp_component_state,
          type: data.rp_type,
          description: [`${data.rp_description}`],
        },
      ],
    };

    submitFactor(submitData).then((response) => {});
  };

  return (
    <div className="bg-pr_yellow rounded-lg mt-10 lg:mt-20 px-5 py-10">
      <h3 className="text-center font-rokh font-[900] text-xl">
        ثبت فاکتور جدید
      </h3>

      <div className="mt-5">
        <form
          onSubmit={handleSubmit(onSubmit)}
          className="flex-1 w-full flex flex-col justify-between max-w-lg"
        >
          <div className="flex-1 my-5">
            <Input
              form={form}
              errors={errors}
              title="لیبل"
              placeholder=""
              id="name"
            />
            <Select
              form={form}
              errors={errors}
              title="آزمایش"
              id="usage_type"
              options={usageOptions}
            />
            <Input
              form={form}
              errors={errors}
              title="نام کامل"
              placeholder=""
              id="complete_name"
            />
            <Input
              form={form}
              errors={errors}
              title="نام فارسی"
              placeholder=""
              id="fa_name"
            />
            <Input
              form={form}
              errors={errors}
              title="واحد"
              placeholder=""
              id="unit"
            />
            <Textarea
              form={form}
              errors={errors}
              title="کاربرد"
              placeholder=""
              id="description"
            />
            <Select
              form={form}
              errors={errors}
              title="نوع"
              id="result_type"
              options={resultTypeOptions}
            />
            <Textarea
              form={form}
              errors={errors}
              title="نام‌های پرتکرار"
              placeholder="با space جدا کنید"
              id="similar_names"
            />
            <Textarea
              form={form}
              errors={errors}
              title="حالت نرمال"
              placeholder=""
              id="normal_situation"
            />
            -------------------------------- دلایل و مشکلات:
            <Select
              form={form}
              errors={errors}
              title="جنسیت"
              id="rp_sex"
              options={sexOptions}
            />
            <Select
              form={form}
              errors={errors}
              title="وضعیت"
              id="rp_component_state"
              options={componentStateOptions}
            />
            <Select
              form={form}
              errors={errors}
              title="نوع"
              id="rp_type"
              options={typeOptions}
            />
            <Textarea
              form={form}
              errors={errors}
              title="توضیح"
              placeholder=""
              id="rp_description"
            />
          </div>

          <LoadingButton
            title="ارسال"
            type="submit"
            disabled={!isValid || !isDirty}
          />
        </form>
      </div>
    </div>
  );
};

export default InvalidComponentsForm;
